// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Pervasives from "@rescript/runtime/lib/es6/Pervasives.js";

let context = React.createContext([
  undefined,
  param => {}
]);

function use() {
  let match = React.useContext(context);
  let state = match[0];
  if (state !== undefined) {
    return [
      state,
      match[1]
    ];
  } else {
    return Pervasives.failwith("Could not find Notifier context value");
  }
}

let Context = {
  context: context,
  use: use
};

let make = context.Provider;

function makeProps(value, children, param) {
  return {
    value: value,
    children: children
  };
}

let Provider = {
  make: make,
  makeProps: makeProps
};

export {
  Context,
  Provider,
}
/* context Not a pure module */
